import { Helmet } from "react-helmet-async";

export default function SchemaMarkup({ schemas }) {
  // Ensure schemas is always an array
  const schemaArray = Array.isArray(schemas) ? schemas : [schemas];

  return (
    <Helmet>
      {schemaArray.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
